import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import _ from 'lodash/fp';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useQuery, useMutation } from '@apollo/client';
import { NOTIFICATION, UPDATE_NOTIFICATION } from '@api';
import { notificationTypes, getNotificationColor } from '../../shared/sparkLib/notificationTypes';

export default function EditNotification(props) {
  const history = useHistory();
  const [form_errors, setErrors] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [notificationType, setNotificationType] = useState('primary');
  const { id: notificationId } = useParams();
  useQuery(NOTIFICATION, {
    variables: { id: parseInt(notificationId) },
		fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setTitle(data && data.notification ? data.notification.title : '');
      setDescription(
        data && data.notification ? data.notification.description : ''
      );
			setNotificationType(data?.notification ? data.notification.notificationType : 'primary');
    },
    onError: (error) => {
      console.log(error + '>>>>> ERROR >>>>>');
      toast('Notification not found', { type: 'error' });
      props.sidebarToggle();
    },
  });
  const [notificationUpdate] = useMutation(UPDATE_NOTIFICATION, {
    onCompleted: (data) => {
      if (
        data.notificationUpdate.errors &&
        data.notificationUpdate.errors.length > 0
      ) {
        setErrors(data.notificationUpdate.errors);
      } else {
        toast('Notification update successfully', { type: 'success' });
        props.sidebarToggle();
        props.shouldRefetch(true);
        history.push(`/notifications`);
        document.getElementById('addNotification').reset();
      }
    },
    onError: (e) => {
      console.log(e, 'error');
    },
  });

  const { register, handleSubmit, errors } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    notificationUpdate({
      variables: {
        id: parseInt(notificationId),
        title: data.title,
        description: data.description,
				notificationType: notificationType
      },
    });
  };

	function handleNotificationType(e) {
		setNotificationType(e.target.value);
	}

  return (
    <>
      <Container className='p-4'>
        <Row>
          <Col md='12'>
            <h4>Edit Notification</h4>
          </Col>
          <Col md='12'>
            {form_errors.length > 0 ? (
              <Col>
                {form_errors.map((err) => (
                  <Col className='bg-danger mt-2 text-white'>{err}</Col>
                ))}
              </Col>
            ) : null}
          </Col>
          <Col md='12' className='mt-md-3'>
            <Form id='addNotification' onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg='12'>
                  <Row>
                    <Col md='12'>
                      <FormGroup>
                        <Label for='firstName'>Title</Label>
                        <Input
                          type='text'
                          placeholder='Title'
                          name='title'
                          autoComplete='off'
                          innerRef={register({
                            required: true,
                          })}
                          defaultValue={title}
                          onChange={(e) => {
                            setTitle(e.target.value);
                          }}
                        />
                        {_.get('title.type', errors) === 'required' && (
                          <p className='input-error'>* Title required.</p>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md='12'>
                      <FormGroup>
                        <Label for='notificationType'>Notification Type</Label>
                        <select value={notificationType} class="custom-select notification-type-select" onChange={handleNotificationType} style={{backgroundColor: getNotificationColor(notificationType)}}>
													{notificationTypes.map((notification) => {
														return (
															<option value={notification.notificationType} style={{backgroundColor: notification.color}}>{_.capitalize(notification.notificationType)}</option>
														)
													})}
												</select>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md='12'>
                      <FormGroup>
                        <Label for='lastName'>Description</Label>
                        <Input
                          type='textarea'
                          placeholder='Description'
                          name='description'
                          autoComplete='off'
                          innerRef={register({
                            required: true,
                          })}
                          style={{ height: '120px' }}
                          defaultValue={description}
                          onChange={(e) => {
                            setDescription(e.target.value);
                          }}
                        />
                        {_.get('description.type', errors) === 'required' && (
                          <p className='input-error'>* Description required.</p>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Col lg='12' className='mt-md-4'>
                  <Row>
                    <Col xs='12' className='text-left'>
                      <Button color='primary' className='button-dashboard'>
                        Update
                      </Button>
                      <Button
                        color='secondary'
                        className='button-dashboard ml-2'
                        onClick={() => props.sidebarToggle()}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}
